import { ChangeEvent, useRef, useState } from 'react';
import { useUploadLogoFunction } from 'components/Reports/ui/ReportLogo';
import useLogoUrlReplacement from 'components/Dashboard/UserContent/ui/useLogoUrlReplacement';

interface UploadHubLogoPickerProps {
  logo: string | null;
  setLogo: (logo: string | null) => void;
}

const UploadHubLogoPicker = ({ logo, setLogo }: UploadHubLogoPickerProps) => {
  const { clientLogoReplacement } = useLogoUrlReplacement();
  const { uploadLogoFile } = useUploadLogoFunction({ logo: null });
  const [isUploading, setIsUploading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const logoUrl = logo?.startsWith('data:') ? logo : clientLogoReplacement({ organisationLogo: logo });

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setIsUploading(true);
    try {
      const result = await uploadLogoFile({ e, setTemporaryLogo: undefined });
      if (result) setLogo(result[0]);
    } finally {
      setIsUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div className='flex-centered'>
      {logo && (
        <img
          className='rounded bg-white border mr-3 '
          src={logoUrl}
          alt='Organisation logo'
          style={{ width: '48px', height: '48px', objectFit: 'contain' }}
        />
      )}
      <label
        htmlFor='uploadHubLogoInput'
        className={`general-button rounded-pill border text-light-blue specific-top-padding-2 specific-bottom-padding-3 paragraph-p2 specific-x-padding-16 rounded mb-0 pointer hovered-button ${isUploading ? 'disabled-button' : ''}`}
      >
        {isUploading && <i className='fas fa-spinner fa-spin d-inline-block-centered mr-2' />}
        {logo ? 'Replace logo' : 'Add a logo'}
      </label>
      {logo && (
        <button
          type='button'
          disabled={isUploading}
          className='general-button rounded-pill border text-main-danger specific-top-padding-2 specific-bottom-padding-3 paragraph-p2 specific-x-padding-16 rounded ml-2 mb-0 pointer hovered-button'
          onClick={() => setLogo(null)}
        >
          Delete logo
        </button>
      )}
      <input
        ref={inputRef}
        id='uploadHubLogoInput'
        type='file'
        hidden
        disabled={isUploading}
        accept='image/png, image/gif, image/jpeg'
        onChange={handleChange}
      />
    </div>
  );
};

export default UploadHubLogoPicker;
